import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PendingVerificationComponent } from './pending-verification.component';
import { TranslateModule, AlertListModule } from '@xref/ngx';

@NgModule({
    declarations: [PendingVerificationComponent],
    imports: [
        CommonModule,
        TranslateModule,
        AlertListModule,
    ],
    exports: [PendingVerificationComponent]
})
export class PendingVerificationModule {}
